import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import StepPersonalAndPayment from 'components/StepPersonalAndPayment';
import { COLOR_GRAY_70, COLOR_PINK } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 28,
    fontWeight: 700,
    fontFamily: theme.typography.fontFamily,
    color: COLOR_GRAY_70,
    textAlign: 'center',
    marginBottom: theme.spacing(2),

    '& span': {
      color: COLOR_PINK,
    },
  },
  description: {
    fontSize: 16,
    fontFamily: theme.typography.fontFamily,
    color: '#212121',
    marginBottom: theme.spacing(5),
  },
}));

export default function CheckoutProcessInformation() {
  const classes = useStyles();

  return (
    <Box display="flex" justifyContent="center" width="100%">
      <Box pt={4}>
        <StepPersonalAndPayment inactiveStep={1} />

        <Typography className={classes.title}>
          Subscribe to your <span>Mind the Graph plan</span>
        </Typography>

        <Typography className={classes.description}>
          We need some more information before you start creating more elaborated infographics
        </Typography>
      </Box>
    </Box>
  );
}
